import * as global from '@/scripts/core/global'
const { ON_CHANGE_DEBOUNCE_TIMER, PUB_SUB_EVENTS, ATTRIBUTES, SELECTORS } = global
export { ON_CHANGE_DEBOUNCE_TIMER, PUB_SUB_EVENTS, ATTRIBUTES, SELECTORS }
global.globalSetup()
